module.exports = __webpack_public_path__ + "04850a2414ba46fb33c9e0dd670a1a12.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/flat/yellow@2x.png
// module id = 296
// module chunks = 0